import React, { useEffect, useState } from "react";
import Card from "components/card";
import Button from "components/button";
import { getAgeGrades, deleteAgeGrade } from "services/ageGrades";
import { useToast } from "components/Toast";
import { useNavigate, Link } from "react-router-dom";

const AgeGradesAdmin: React.FC = () => {
  const [grades, setGrades] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await getAgeGrades();
        setGrades(Array.isArray(data?.data) ? data.data : []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleDelete = async (id: number) => {
    if (!window.confirm("Delete age grade?")) return;
    try {
      await deleteAgeGrade(id);
      setGrades((prev) => prev.filter((g) => g.id !== id));
    } catch (err) {
      console.error(err);
      toast.showError("Failed to delete age grade");
    }
  };

  return (
    <Card extra="w-full p-4">
      <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-2xl font-bold text-gray-900">Age Grades</h2>
        <div className="mt-3 sm:mt-0">
          <Button as="link" to="/admin/age-grades/create">
            Create Age Grade
          </Button>
        </div>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : grades.length === 0 ? (
        <p className="text-gray-500">No age grades yet.</p>
      ) : (
        <div className="space-y-4">
          {grades.map((g) => (
            <div
              key={g.id}
              className="flex flex-col rounded bg-white p-4 shadow-sm dark:bg-navy-700 md:flex-row md:items-center md:justify-between"
            >
              <div>
                <h3 className="font-semibold">{g.name}</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300">
                  {g.description}
                </p>
              </div>
              <div className="mt-3 flex items-center space-x-2 md:mt-0">
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => navigate(`/admin/age-grades/${g.id}/edit`)}
                >
                  Edit
                </Button>
                <Button
                  size="sm"
                  variant="danger"
                  onClick={() => handleDelete(g.id)}
                >
                  Delete
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export default AgeGradesAdmin;
// (removed duplicate placeholder)
